import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import FirstLoginScreen from './FirstLoginScreen';

export default function RequireAuth({ children }) {
  const { session, needsPasswordChange, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center text-[#0B1B5E]" data-testid="auth-loading">Cargando…</div>;
  }
  if (!session) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  if (needsPasswordChange) {
    return <FirstLoginScreen />;
  }
  return children;
}
